import { filter } from 'lodash'
import React from 'react'
import Manager from 'tyan/public/components/Manager'
import ExpenseOrder from './ExpenseOrder'
Ext.require('Ext.Toast')

const config = {
	buttons: [
	],
	export: true,
	exportColumns: [
		{ _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
		{ _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
		{ _text: '状态名称', field: 'StatusName', minWidth: 150, flex: 1, search: true },
		{ _text: '签核人', field: '_Signatory', minWidth: 150, flex: 1 },
		{ _float: '支付金额', field: 'PayAmount', minWidth: 150, flex: 1, zeroValue: null },
		{ _text: '报支对象', field: 'CustomerName', minWidth: 200, flex: 1, search: true },
		{ _text: '用途说明', field: 'UseDescription', minWidth: 300, flex: 1, search: true },
		{ _text: '报支单类型', field: 'ExpenseName', minWidth: 150, flex: 1, search: true },
		{ _text: '报支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
		{ _text: '报支人', field: 'RelatedPerson', minWidth: 150, flex: 1, search: true },
		{ _text: '采购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
		{ _text: '申请部门', field: '_CreateDep', minWidth: 150 },
		{ _text: '合同编号', field: 'ContractNumber', minWidth: 150, flex: 1, /* filter: true, sortable: false */ },
		{ _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
		//{ _text: '安环费用支出', field: 'NewSafetyEnvironmentFee', minWidth: 150, flex: 1, search: true },
	],
	columns: [
		{ _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, filter: true, },
		{ _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
		{ _text: '状态名称', field: 'StatusName', minWidth: 150, flex: 1, search: true },
		{ _text: '签核人', field: '_Signatory', minWidth: 150, flex: 1 },
		{ _float: '支付金额', field: 'PayAmount', minWidth: 150, flex: 1, zeroValue: null, filter: true },
		{ _text: '报支对象', field: 'CustomerName', renderer: (v, r) => r.data.报支名称 == '交际费报支单' ? r.data.报支人 : r.data.报支对象, minWidth: 200, flex: 1, filter: false },
		{ _text: '用途说明', field: 'UseDescription', minWidth: 300, flex: 1, search: true },
		{ _text: '报支单类型', field: 'ExpenseName', minWidth: 150, flex: 1, search: true },
		{ _text: '报支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
		{ _text: '报支人', field: 'RelatedPerson', minWidth: 150, flex: 1, search: true },
		{ _text: '采购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
		{ _text: '申请部门', field: '_CreateDep', minWidth: 150, },
		{ _text: '合同编号', field: 'ContractNumber', minWidth: 150, flex: 1, search: true },
		{ _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
		{ _date: '完成时间', field: 'AdvanceExpenseLog.LogTime', minWidth: 120, flex: 1, filter: true, },	
		// {
		//     _text: '安环费用支出', field: 'NewSafetyEnvironmentFee', minWidth: 150, flex: 1, search: true,filter:['select','安环费用支出',['是','否']],   
		//     renderer: (安环费用支出, { data: { 报支名称 } = {} }) => <span>{报支名称 == "一般报支单" || 报支名称 == "采购报支单" ? 安环费用支出 : ''}</span>
		// },
		{ _: '报支名称', field: 'ExpenseName', minWidth: 150, flex: 1, search: true },
		{ _: '报支对象', field: 'CustomerName', minWidth: 150, flex: 1, search: true },
		{ _: '报支人', field: 'RelatedPerson', minWidth: 150, flex: 1, search: true },
	],
	onDoubleTap: ({ showDetail, refreshPage }, data) => {
		showDetail(props => <ExpenseOrder {...props} id={data.id} readOnly={true} />)
	}
}

export default props => <Manager {...props} config={config} />